// Tipo de producto que pintan Inventario y el Catálogo del vendedor: SIM y módem comparten tipo,
// el kit sale de `BUNDLE` y el servicio de `itemType`.
import type { ProductCategoryEnum } from '@fiado/type-kit/bin/retailCatalog/enums/ProductCategoryEnum';
import type { ItemTypeEnum } from '@fiado/type-kit/bin/retailCatalog/enums/ItemTypeEnum';

export type ProductKind =
    | 'PHONE'
    | 'SIM_MODEM'
    | 'ACCESSORY'
    | 'KIT'
    | 'SERVICE'
    | 'CARD'
    | 'PREPAID';

/** Tipos en el orden del mock; Kit y Servicio van tras Accesorio. */
export const PRODUCT_KIND_OPTIONS: readonly { value: ProductKind; label: string }[] = [
    { value: 'PHONE', label: 'Teléfono' },
    { value: 'SIM_MODEM', label: 'SIM/Módem' },
    { value: 'ACCESSORY', label: 'Accesorio' },
    { value: 'KIT', label: 'Kit' },
    { value: 'SERVICE', label: 'Servicio' },
    { value: 'CARD', label: 'Tarjeta' },
    { value: 'PREPAID', label: 'Prepago' },
];

export const PRODUCT_KIND_LABEL: Record<ProductKind, string> = Object.fromEntries(
    PRODUCT_KIND_OPTIONS.map((o) => [o.value, o.label]),
) as Record<ProductKind, string>;

const KIND_BY_CATEGORY: Record<Exclude<`${ProductCategoryEnum}`, 'BUNDLE'>, ProductKind> = {
    PHONE: 'PHONE',
    SIM: 'SIM_MODEM',
    MODEM: 'SIM_MODEM',
    ACCESSORY: 'ACCESSORY',
};

/** Un servicio se reconoce por `itemType`, no por su categoría; el kit por `BUNDLE`. */
export function productKindOf(
    category: `${ProductCategoryEnum}`,
    itemType?: `${ItemTypeEnum}`,
): ProductKind {
    if (itemType === 'SERVICE') return 'SERVICE';
    if (category === 'BUNDLE') return 'KIT';
    return KIND_BY_CATEGORY[category];
}
